"use client";
import * as React from "react";
const SvgAutoOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.72 4.57 14.43 3 16 2.3l-1.57-.72L13.72 0 13 1.57l-1.57.72L13 3zm-8.77 0L5.67 3l1.57-.71-1.57-.72L4.95 0l-.71 1.57-1.57.72L4.24 3zm8.77 4.2L13 10.32l-1.57.72 1.57.71.72 1.57.71-1.57 1.57-.71-1.57-.72zm-1.75-2.58L9.81 4.03a.8.8 0 0 0-.54-.22.8.8 0 0 0-.54.22l-8.5 8.51a.76.76 0 0 0 0 1.08l2.15 2.15a.8.8 0 0 0 .54.23.8.8 0 0 0 .54-.22l8.51-8.51a.77.77 0 0 0 0-1.08m-2.7-.54 1.08 1.08-.9.89-1.07-1.07zm-6.35 8.51L1.85 13.1 7.3 7.62l1.07 1.07z" }));
export {
  SvgAutoOutlined as default
};
